export const median = (arr: number[]): number => {
  if (!arr) return 0
  if (!arr.length) return 0
  const s = [...arr].sort((a, b) => a - b)
  const mid = Math.floor(s.length / 2)
  return s.length % 2 === 0 ? (s[mid - 1] + s[mid]) / 2 : s[mid]
}

export const calculateMedianMillis = (cycleTimes: number[]): number => {
  if (!cycleTimes.length) return 0
  return Math.round(median(cycleTimes))
}

export const calculateMedianHours = (cycleTimes: number[]): number => {
  if (!cycleTimes.length) return 0
  return Math.round(median(cycleTimes) / (3600 * 1000))
}
